<template>
  <el-container class="bodybox">
    <el-header>
      <Header />
    </el-header>
    <el-main class="mainbox">
      <div style="width:100%;height:200px" v-loading="loading" v-if="!show"></div>
      <router-view v-if="show" />
    </el-main>
  </el-container>
</template>
<script>
  import Header from "../components/header"
  import { mapGetters } from 'vuex';
  export default {
    computed: {
      ...mapGetters(['api_id', 'roles']),
    },
    components: { Header },
    data() {
      return {
        show: false,
        loading: true
      }
    },
    watch: {
      api_id: {
        handler(data) {
          if (data) {
            this.showpage()
          }
        },
        deep: true,
        immediate: true
      },
      roles: {
        handler(data) {
          if (data) {
            this.showpage()
          }
        },
        deep: true,
        immediate: true
      },
    },
    methods: {
      showpage() {
        this.show = false
        this.loading = true
        setTimeout(() => {
          this.show = true
          this.loading = false
        }, 200);
      }
    },
  }
</script>
<style lang="scss" scoped>
  .bodybox {
    width: 100%;
    min-height: 100vh;
    background: #f0f2f4;
  }
  /deep/.el-header {
    width: 100%;
    height: 64px !important;
    background: #ffffff;
    // border-bottom: 1px solid #babdcd;
  }
  /deep/.el-main {
    width: 100%;
    height: calc(100vh - 64px);
    padding: 0;
  }
</style>>